import { Row, Col, Image } from 'react-bootstrap';


function Neukauf() {
    return (
        <Row>
            <Col className='neukauf text-center py-3'>
                <h3>Neukauf von MAN-Nutzfahrzeugen</h3>
                <Image src="/verkauf.jpg" className='rounded-circle' height="150px" width="150px"/>
                <h4>Nico Boost</h4>
                <p><a className='phone' href={"tel:+492421987516"}>02421 987516</a><br/>
                <a className='phone' href={"tel:+491711098394"}>0171 1098394</a></p>

            </Col>
        </Row>
    );
}

export default Neukauf;